import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_el_tree_select = _resolveComponent("el-tree-select");
  return _openBlock(), _createBlock(_component_el_tree_select, {
    modelValue: _ctx.realValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.realValue = $event),
    disabled: !_ctx.enabled,
    size: _ctx.size,
    loading: _ctx.loading,
    placeholder: _ctx.placeholder,
    data: _ctx.options,
    props: _ctx.treeProps,
    "show-checkbox": true,
    multiple: _ctx.multiple,
    "node-key": _ctx.valueKey,
    "collapse-tags": _ctx.collapseTags,
    "collapse-tags-tooltip": _ctx.collapseTags,
    "default-expand-all": _ctx.defaultExpandAll,
    onBlur: _ctx.onBlur,
    "data-test": _ctx.dataTest,
    onCheck: _ctx.onCheck
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createVNode(_component_w_tool_tip, {
      text: _ctx.isDisabledLeaf(data) ? _ctx.disabledTooltip : '',
      disabled: !_ctx.isDisabledLeaf(data),
      placement: "right"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(node.label), 1)]),
      _: 2
    }, 1032, ["text", "disabled"])]),
    _: 1
  }, 8, ["modelValue", "disabled", "size", "loading", "placeholder", "data", "props", "multiple", "node-key", "collapse-tags", "collapse-tags-tooltip", "default-expand-all", "onBlur", "data-test", "onCheck"]);
}